import { Container } from "@material-ui/core";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

import { Generator } from "../../../components/Generator";
import { Grid } from "../../../components/Grid";
import { Heading } from "../../../components/Heading";
import { Sidebar } from "../../../components/Navigation/Sidebar";
import { loadAppData } from "../../../components/appData.slice";
import { FormType } from "../../../components/enums";
import {
  usePreventRefresh,
  useScrollDocument,
  useShouldRedirectToHomepage,
  useShowFooter,
  useTitle,
} from "../../../hooks";
import { Url } from "../../../router/enums";
import { selectIsFormValidated } from "../../Welcome/welcome.selectors";

import styles from "./Vehicle.module.scss";
import { form } from "./form";

export const Vehicle = (): JSX.Element => {
  const dispatch = useDispatch();
  useShouldRedirectToHomepage(selectIsFormValidated);
  useShowFooter();
  useTitle("Ayvens AC");
  usePreventRefresh();
  useScrollDocument();

  //JIRA LPPLWEBMOB-750
  //Kod odpalany wyłącznie dla bezpośredniego wejścia na scieżkę AC
  useEffect(() => {
    dispatch(loadAppData());
  }, [dispatch]);

  return (
    <Container className={styles.container}>
      <Heading component="h1" variant="h1" spacingBottom={4}>
        Formularz zgłoszenia szkody
      </Heading>
      <Grid
        container
        alignItems="flex-start"
        className={styles.page}
        spacingInnerLeft={{ xs: 5, sm: 10 }}
        spacingInnerRight={{ xs: 5, sm: 10 }}
        direction="row"
      >
        <Sidebar currentRoute={Url.AC_VEHICLE} type={FormType.AC} />
        <Generator
          form={form}
          render={(generatedForm) => (
            <Grid item xs={12} md={8}>
              {generatedForm}
            </Grid>
          )}
        />
      </Grid>
    </Container>
  );
};
